import { depositInvoiceTypes } from './constants'

/**
 * A deposit invoice has a single deposit beneficiary that always pays out the full invoice
 * amount, whether the deposit is managed by reOS or self-managed by the owner. Deposit
 * invoices and invoice templates can be generated with that beneficiary's amount left at
 * zero, which shows the deposit as unallocated, so derive it from the invoice amount
 * instead. An amount that is already set is left untouched.
 */
export const getDepositBeneficiaryAmount = (params: {
  invoiceType: string
  invoiceAmount: number | string
  beneficiaryType: string
  amount: number | string
}): number | string => {
  const { invoiceType, invoiceAmount, beneficiaryType, amount } = params
  const isDepositBeneficiary = depositInvoiceTypes.includes(invoiceType) && beneficiaryType === 'DepositBeneficiary'

  return isDepositBeneficiary && !parseFloat(String(amount)) && invoiceAmount ? invoiceAmount : amount
}

export const getInvoiceTypeDisplayName = (invoiceType: string) => {
  switch (invoiceType) {
    case 'Application-Fee':
      return 'Application Fee'
    default:
      return invoiceType
  }
}
